import React from "react";
import "./Footer.css";
import {FaFacebookF} from "react-icons/fa";
import {IoLogoTwitter} from "react-icons/io";
import {FaLinkedinIn} from "react-icons/fa";

const Footer = ()=>{
    return (
        <footer>
            <a href="#" className="footer__logo">dk-jaiswal-77</a>

            <ul className="permalinks">
                <li><a href="#">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#skills">Skills</a></li>
                <li><a href="#projects">Projects</a></li>
                <li><a href="#contact">Contact</a></li>    
            </ul>

            <div className="footer__socials">
                <a href="https://www.facebook.com/profile.php?id=100072096787997" target={"_blank"}>< FaFacebookF /></a>
                <a href="https://twitter.com" target={"_blank"}> < IoLogoTwitter /></a>
                <a href="https://www.linkedin.com/in/dhirendra-kumar-jaiswal-949b3a230/" target={"_blank"}> < FaLinkedinIn /></a>
            </div>

            <div className="footer__copyright">
                <small>&copy; dk-jaiswal-77. All rights reserved.</small>
            </div>
        </footer>
    );
}

export default Footer; 